import {
  constantRouterMap
} from '@/router'
import Layout from '@/layout'
import store from '../../store'

/**
 * 通过meta.permission判断是否与当前用户权限匹配
 * @param permission
 * @param route
 */
function hasPermission(route) {
  if (route && route.hasOwnProperty('meta') && route.meta.hasOwnProperty('permission')) {
    // 判断当前用户权限是否可看
    if (route.meta.permission) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 */
function filterAsyncRouter(routes) {
  const res = []
  routes.forEach(route => {
    const tmp = {
      ...route
    }
    if (hasPermission(tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children)
      }
      res.push(tmp)
    }
  })
  return res
}

const authorization = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({
      commit
    }, userInfo) {
      return new Promise(resolve => {
        var permissions = store.getters.permissions;
        const asyncRouterMap = [{
          path: '/estate',
          component: Layout,
          name: 'estate',
          redirect: {
            name: 'estateList'
          },
          meta: {
            title: '楼盘管理'
          },
          children: [{
            path: 'index',
            component: () => import('@/pages/estate/index.vue'),
            name: 'estateList',
            meta: {
              title: '楼盘列表'
            },
          },
          {
            path: 'create',
            component: () => import('@/pages/estate/create.vue'),
            name: 'estateCreate',
            meta: {
              title: '添加楼盘'
            },
          },
          {
            path: 'detail/:id',
            component: () => import('@/pages/estate/detail/index.vue'),
            name: 'estateDetail',
            meta: {
              title: '楼盘详情'
            },
          },
          ]
        },
        {
          path: '/ads',
          component: Layout,
          name: 'ads',
          redirect: {
            name: 'adsList'
          },
          meta: {
            title: '广告管理'
          },
          children: [{
            path: 'index',
            component: () => import('@/pages/ads/index.vue'),
            name: 'adsList',
            meta: {
              title: '广告列表'
            },
          },
          {
            path: 'ads-create',
            component: () => import('@/pages/ads/create.vue'),
            name: 'adsCreate',
            meta: {
              title: '添加广告'
            },
          },
          {
            path: 'ads-details/:id',
            component: () => import('@/pages/ads/subpage/details.vue'),
            name: 'adsDetail',
            meta: {
              title: '广告详情'
            },
          },
          ]
        },
        {
          path: '/information',
          component: Layout,
          name: 'information',
          redirect: {
            name: 'informationList'
          },
          meta: {
            title: '资讯管理'
          },
          children: [
            {
              path: 'information',
              component: () => import('@/pages/information/index'),
              name: 'informationList',
              meta: {
                title: '资讯管理',
                icon: 'router-child',
                // permission: permissions['Coupon.Templates']
              }
            },
            {
              hidden: true,
              path: 'information-details/:id',
              component: () => import('@/pages/information/update/basicInfo'),
              name: 'basicInfo',
              meta: {
                title: '管理资讯',
                // permission: ['Coupon.Create']
              }
            },
            {
              hidden: true,
              path: 'information-content/:id',
              component: () => import('@/pages/information/update/detailsInfo'),
              name: 'contentInformation',
              meta: {
                title: '管理正文',
                // permission: ['Coupon.Create']
              }
            },
            {
              hidden: true,
              path: 'information-preview/:id',
              component: () => import('@/pages/information/update/previewInformation'),
              name: 'previewInformation',
              meta: {
                title: '资讯预览',
                // permission: ['Coupon.Create']
              }
            },
            {

              hidden: true,
              path: 'information-create',
              component: () => import('@/pages/information/create'),
              name: 'createInformation',
              meta: {
                title: '添加资讯',
                // permission: ['Coupon.Create']
              }
            },
          ]
        },
        {
          path: '/reservation',
          component: Layout,
          name: 'reservation',
          redirect: {
            name: 'reservationList'
          },
          meta: {
            title: '报备管理'
          },
          children: [{
            path: 'index',
            component: () => import('@/pages/reservation/index.vue'),
            name: 'reservationList',
            meta: {
              title: '报备列表'
            },

          },
          {
            path: '/reservation/create',
            component: () => import('@/pages/reservation/create-reservation.vue'),
            name: 'createReservation',
            meta: {
              title: '添加报备'
            },
          },
          {
            path: '/reservation/visit/:id',
            component: () => import('@/pages/reservation/visit-reservation.vue'),
            name: 'visitReservation',
            meta: {
              title: '录入带看'
            },
          },
          {
            path: '/reservation/detail/:id',
            component: () => import('@/pages/reservation/reservation-details.vue'),
            name: 'reservationDetails',
            meta: {
              title: '报备详情'
            },
          }
          ]
        },
        // {
        //   path: '/transaction',
        //   component: Layout,
        //   name: 'transaction',
        //   redirect: {
        //     name: 'transactionMine'
        //   },
        //   meta: {
        //     title: '交易管理',
        //     permission: ['Transaction']
        //   },
        //   children: [
        //     {
        //       path: 'mine',
        //       component: () => import('@/pages/transaction/mine/index.vue'),
        //       name: 'transactionMine',
        //       meta: {
        //         title: '我的交易'
        //       },
        //       children: [
        //         {
        //           path: 'create',
        //           component: () => import('@/pages/transaction/mine/create.vue'),
        //           name: 'mineCreate',
        //           meta: {
        //             title: '新增交易'
        //           },
        //         },
        //         {
        //           path: 'update/:id',
        //           component: () => import('@/pages/transaction/mine/update.vue'),
        //           name: 'mineUpdate',
        //           meta: {
        //             title: '编辑交易'
        //           },
        //         },
        //         {
        //           path: 'detail/:id',
        //           component: () => import('@/pages/transaction/mine/detail.vue'),
        //           name: 'transactionDetail',
        //           meta: {
        //             title: '交易详情'
        //           },
        //           children:[
        //             {
        //               path: 'follow',
        //               component: () => import('@/pages/transaction/mine/pages/follow.vue'),
        //               name: 'transactionFollow',
        //               meta: {
        //                 title: '跟进记录'
        //               },
        //             },
        //             {
        //               path: 'recognition/create',
        //               component: () => import('@/pages/transaction/mine/pages/recognition/create.vue'),
        //               name: 'recognitionCreate',
        //               meta: {
        //                 title: '新增认筹'
        //               },
        //             },
        //             {
        //               path: 'recognition/update',
        //               component: () => import('@/pages/transaction/mine/pages/recognition/update.vue'),
        //               name: 'recognitionUpdate',
        //               meta: {
        //                 title: '编辑认筹'
        //               },
        //             },
        //             {
        //               path: 'recognition/detail',
        //               component: () => import('@/pages/transaction/mine/pages/recognition/detail.vue'),
        //               name: 'recognitionDetail',
        //               meta: {
        //                 title: '认筹详情'
        //               },
        //             },
        //             {
        //               path: 'subscription/create',
        //               component: () => import('@/pages/transaction/mine/pages/subscription/create.vue'),
        //               name: 'subscriptionCreate',
        //               meta: {
        //                 title: '新增认购'
        //               },
        //             },
        //             {
        //               path: 'subscription/update',
        //               component: () => import('@/pages/transaction/mine/pages/subscription/update.vue'),
        //               name: 'subscriptionUpdate',
        //               meta: {
        //                 title: '编辑认购'
        //               },
        //             },
        //             {
        //               path: 'subscription/detail',
        //               component: () => import('@/pages/transaction/mine/pages/subscription/detail.vue'),
        //               name: 'subscriptionDetail',
        //               meta: {
        //                 title: '认购详情'
        //               },
        //             },
        //             {
        //               path: 'signed/create',
        //               component: () => import('@/pages/transaction/mine/pages/signed/create.vue'),
        //               name: 'signedCreate',
        //               meta: {
        //                 title: '新增签约'
        //               },
        //             },
        //             {
        //               path: 'signed/update',
        //               component: () => import('@/pages/transaction/mine/pages/signed/update.vue'),
        //               name: 'signedUpdate',
        //               meta: {
        //                 title: '编辑签约'
        //               },
        //             },
        //             {
        //               path: 'signed/detail',
        //               component: () => import('@/pages/transaction/mine/pages/signed/detail.vue'),
        //               name: 'signedDetail',
        //               meta: {
        //                 title: '签约详情'
        //               },
        //             },
        //             {
        //               path: 'collect/create',
        //               component: () => import('@/pages/transaction/mine/pages/collect/create.vue'),
        //               name: 'collectCreate',
        //               meta: {
        //                 title: '新增收款'
        //               },
        //             },
        //             {
        //               path: 'collect/update/:collectId',
        //               component: () => import('@/pages/transaction/mine/pages/collect/update.vue'),
        //               name: 'collectUpdate',
        //               meta: {
        //                 title: '编辑收款'
        //               },
        //             },
        //             {
        //               path: 'collect/detail/:collectId',
        //               component: () => import('@/pages/transaction/mine/pages/collect/detail.vue'),
        //               name: 'collectDetail',
        //               meta: {
        //                 title: '收款详情'
        //               },
        //             },
        //             {
        //               path: 'collect/print/:collectId',
        //               component: () => import('@/pages/transaction/mine/pages/collect/print.vue'),
        //               name: 'collectPrint',
        //               meta: {
        //                 title: '打印收据'
        //               },
        //             }, 
        //             {
        //               path: 'payment/create',
        //               component: () => import('@/pages/transaction/mine/pages/payment/create.vue'),
        //               name: 'paymentCreate',
        //               meta: {
        //                 title: '新增付款'
        //               },
        //             }, 
        //             {
        //               path: 'payment/detail/:paymentId',
        //               component: () => import('@/pages/transaction/mine/pages/payment/detail.vue'),
        //               name: 'paymentDetail',
        //               meta: {
        //                 title: '付款详情'
        //               },
        //             },
        //             {
        //               path: 'achievement/create',
        //               component: () => import('@/pages/transaction/mine/pages/achievement/create.vue'),
        //               name: 'achievementCreate',
        //               meta: {
        //                 title: '新增业绩'
        //               },
        //             },
        //             {
        //               path: 'achievement/detail',
        //               component: () => import('@/pages/transaction/mine/pages/achievement/detail.vue'),
        //               name: 'achievementDetail',
        //               meta: {
        //                 title: '业绩详情'
        //               },
        //             },  
        //             {
        //               path: 'achievement/update',
        //               component: () => import('@/pages/transaction/mine/pages/achievement/update.vue'),
        //               name: 'achievementUpdate',
        //               meta: {
        //                 title: '修改业绩'
        //               },
        //             },  
        //             {
        //               path: 'achievement-plans/update/:achievementId',
        //               component: () => import('@/pages/transaction/mine/pages/achievement/plans/update.vue'),
        //               name: 'achievementPlansUpdate',
        //               meta: {
        //                 title: '修改分成'
        //               },
        //             },
        //             {
        //               path: 'achievement-plans/detail/:achievementId',
        //               component: () => import('@/pages/transaction/mine/pages/achievement/plans/detail.vue'),
        //               name: 'achievementPlansDetail',
        //               meta: {
        //                 title: '分成详情'
        //               },
        //             },                      
        //           ]
        //         },
        //       ]
        //     },
        //     {
        //       path: 'achievement',
        //       component: () => import('@/pages/transaction/achievement/index.vue'),
        //       name: 'achievementPlan',
        //       meta: {
        //         title: '业绩分成'
        //       },
        //     },
        //     {
        //       path: 'commission',
        //       component: () => import('@/pages/transaction/commission/index.vue'),
        //       name: 'commission',
        //       meta: {
        //         title: '结佣管理'
        //       },
        //     },
        //   ]
        // },
        {
          path: '/customer',
          component: Layout,
          name: 'customer',
          redirect: {
            name: 'customerList'
          },
          meta: {
            title: '客源管理'
          },
          children: [{
            path: 'index',
            component: () => import('@/pages/customer/index.vue'),
            name: 'customerList',
            meta: {
              title: '客源列表'
            },
          },
          {
            path: 'create',
            component: () => import('@/pages/customer/create.vue'),
            name: 'customerCreate',
            meta: {
              title: '添加客源'
            },
          },
          {
            path: 'detail/:id',
            component: () => import('@/pages/customer/detail/index.vue'),
            name: 'customerDetail',
            meta: {
              title: '客源详情'
            },
          },
          {
            path: 'update/:id',
            component: () => import('@/pages/customer/update.vue'),
            name: 'customerUpdate',
            meta: {
              title: '编辑客源'
            },
          },
          ]
        },
        {
          path: '/channel',
          component: Layout,
          name: 'channel',
          redirect: {
            name: 'channelBusiness'
          },
          meta: {
            title: '分销商管理'
          },
          children: [
            {
              path: 'business',
              component: () => import('@/pages/channel/subpage/business/index.vue'),
              name: 'channelBusiness',
              meta: {
                title: '分销商'
              },
              children: [{
                hidden: true,
                path: 'create',
                component: () => import('@/pages/channel/subpage/business/create/index.vue'),
                name: 'lwCompanyCreate'
              }, {
                hidden: true,
                path: 'management/:id',
                component: () => import('@/pages/channel/subpage/business/management/index.vue'),
                name: 'lwCompanyManagement'
              }, {
                hidden: true,
                path: 'material-details/:id',
                component: () => import('@/pages/channel/subpage/business/management/material-details.vue'),
                name: 'lwCompanyMaterialDetails'
              }]
            },
            {
              path: 'franchisee',
              component: () => import('@/pages/channel/subpage/franchisee/index.vue'),
              name: 'channelFranchisee',
              meta: {
                title: '分销商门店'
              },
              children: [{
                hidden: true,
                path: 'create',
                component: () => import('@/pages/channel/subpage/franchisee/create/index.vue'),
                name: 'lwCompanyStoreCreate'
              }, {
                hidden: true,
                path: 'management/:id',
                component: () => import('@/pages/channel/subpage/franchisee/management/index.vue'),
                name: 'lwCompanyStoreManagement'
              }, {
                hidden: true,
                path: 'material-details/:id',
                component: () => import('@/pages/channel/subpage/franchisee/management/material-details.vue'),
                name: 'lwCompanyStoreMaterialDetails'
              }]
            },
            {
              path: 'employe',
              component: () => import('@/pages/hr/subpage/employe/index'),
              name: 'employe',
              meta: {
                title: '分销人员'
              },

              children: [{
                path: 'create',
                component: () => import('@/pages/hr/subpage/employe/create'),
                name: 'createEmploye',
                meta: {
                  title: '添加新员工'
                },
              },
              {
                path: 'print/:id',
                component: () => import('@/pages/hr/subpage/employe/management/print'),
                name: 'print',
                meta: {
                  title: '打印工牌'
                },
              },
              {
                path: 'information/:status/:id',
                component: () => import('@/pages/hr/subpage/employe/management/printInfo'),
                name: 'printInfo',
                meta: {
                  title: '打印电子档案'
                },
              },

              {
                path: 'material-details/:id',
                component: () => import('@/pages/hr/subpage/employe/management/material-details'),
                name: 'materialDetails',
                meta: {
                  title: '上传用户资料详情'
                }
              },
              ]
            },
            {
              path: 'employe/management/:id',
              component: () => import('@/pages/hr/subpage/employe/management/index'),
              name: 'managementEmploye',
              meta: {
                title: '人员详情'
              },
            },
            {
              path: 'position',
              component: () => import('@/pages/hr/subpage/position/index'),
              name: 'position',
              meta: {
                title: '职务职级',
                permission: permissions['RocketIdentity.Positions']
              }
            },
            {
              path: 'organization',
              component: () => import('@/pages/hr/subpage/organization/index'),
              name: 'organization',
              meta: {
                title: '组织架构',
                permission: permissions['RocketIdentity.OrganizationUnits']
              }
            },
            {
              path: 'change-record',
              component: () => import('@/pages/hr/subpage/change-record/index'),
              name: 'changeRecord',
              meta: {
                title: '员工异动记录'
              }
            },
            {
              path: 'personnel-report',
              component: () => import('@/pages/hr/subpage/personnelReport/index'),
              name: 'personnelReport',
              meta: {
                title: '人事报表'
              }
            },
            {
              path: 'personnel-details',
              component: () => import('@/pages/hr/subpage/personnelReport/details'),
              name: 'personnelDetails',
              meta: {
                title: '人事报表详情'
              }
            },
            {
              path: 'statistical-summary',
              component: () => import('@/pages/hr/subpage/statisticalSummary/index'),
              name: 'statisticalSummary',
              meta: {
                title: '统计总表'
              }
            },
            // {
            //   path: 'report',
            //   component: () => import('@/pages/hr/subpage/report/index'),
            //   name: 'hrReport',
            //   meta: {
            //     title: 'HR统计报表'
            //   }
            // },
            {
              path: 'chart',
              component: () => import('@/pages/hr/subpage/chart/index'),
              name: 'hrChart',
              meta: {
                title: 'HR图表 V+'
              }
            }
          
          ]
        },
        {
          path: '/hr',
          component: Layout,
          name: 'hr',
          redirect: {
            name: 'employe'
          },
          meta: {
            title: '分销人员',
            permission: permissions['RocketIdentity.Users']
          },
          children: [
            
          ]
        },
        {
          path: '/system',
          component: Layout,
          redirect: {
            name: 'wageBasic'
          },
          name: 'system',
          meta: {
            title: '系统',
          },
          children: [{
            path: 'setting',
            component: () => import('@/pages/system/subpage/setting/index'),
            name: 'systemSetting',
            meta: {
              title: '基础字段设置',
            }
          },
          {
            path: 'area',
            component: () => import('@/pages/system/subpage/area/index'),
            name: 'systemArea',
            meta: {
              title: '地区管理',
              permission: permissions['System.AreaSettings']
            },
          },
          {
            path: 'permission',
            component: () => import('@/pages/system/subpage/permission/index'),
            name: 'systemPermission',
            meta: {
              title: '权限组管理',
              permission: permissions['RocketIdentity.Roles']
            }
          },
          {
            path: 'tenant',
            component: () => import('@/pages/system/subpage/tenant/index'),
            name: 'systemTenant',
            meta: {
              title: '租户管理',
              permission: permissions['System.TenantSettings']
            }
          },
          {
            path: 'version',
            component: () => import('@/pages/system/subpage/version/index'),
            name: 'systemVersion',
            meta: {
              title: '版本管理',
              permission: permissions['RocketSaas.Editions']
            }
          },
          {
            path: 'approve',
            component: () => import('@/pages/system/subpage/approve/index'),
            name: 'systemApprove',
            meta: {
              title: '登录日志',
            }
          },
          {
            path: 'systemMessage',
            component: () => import('@/pages/message/add-message'),
            name: 'systemMessage',
            meta: {
              title: '系统消息',
            }
          },
          ]
        },
        {
          path: '/report',
          component: Layout,
          name: 'report',
          redirect: {
            name: 'report'
          },
          meta: {
            title: '智能报表'
          },
          children: [{
            path: 'estate-report',
            component: () => import('@/pages/report/estate-report/index.vue'),
            name: 'estateReport',
            meta: {
              title: '楼盘数据统计'
            },
          }, {
            path: 'store-performance-report',
            component: () => import('@/pages/report/store-performance-report/index.vue'),
            name: 'storePerformanceReport',
            meta: {
              title: '分销商门店业绩报表'
            },
          },
          {
            path: 'channel-report',
            component: () => import('@/pages/report/channel-report/index.vue'),
            name: 'channelReport',
            meta: {
              title: '渠道数据报表'
            },
          },
          {
            path: 'broker-report',
            component: () => import('@/pages/report/broker-report/index.vue'),
            name: 'brokerReport',
            meta: {
              title: '经纪人数据报表'
            },
          },]
        },
        {
          path: '/personal',
          component: Layout,
          redirect: {
            name: 'personalInformation'
          },
          name: 'personal',
          meta: {
            title: '个人中心',
          },
          children: [{
            path: 'authentication',
            component: () => import('@/pages/personal/subpage/authentication/index'),
            name: 'authentication'
          },
          {
            path: 'information',
            component: () => import('@/pages/personal/subpage/information/index.vue'),
            name: 'personalInformation'
          },
          ]
        },
        {
          path: '/message',
          component: Layout,
          name: 'message',
          hidden: true,
          redirect: {
            name: 'messageList'
          },
          children: [
            {
              path: 'index',
              component: () => import('@/pages/message/index'),
              name: 'messageList',
              meta: {
                title: '消息盒子',
                icon: 'router-child',
                // permission: permissions['Coupon.Templates']
              }
            },
          ]
        },
        {
          path: '/feedback',
          component: Layout,
          name: 'feedback',
          hidden: true,
          redirect: {
            name: 'feedbackForm'
          },
          children: [
            {
              path: 'index',
              component: () => import('@/pages/feedback/index'),
              name: 'feedbackForm',
              meta: {
                title: '反馈',
                icon: 'router-child',
                // permission: permissions['Coupon.Templates']
              }
            },
          ]
        },
        {
          path: '/need-dealt',
          component: Layout,
          name: 'needDealt',
          hidden: true,
          redirect: {
            name: 'needDealtForm'
          },
          children: [
            {
              path: 'index',
              component: () => import('@/pages/need-dealt/index'),
              name: 'needDealtForm',
              meta: {
                title: '待办事项',
                icon: 'router-child',
                // permission: permissions['Coupon.Templates']
              }
            },
          ]
        },
        {
          path: '*',
          redirect: '/404',
          hidden: true
        },
        {
          path: '/temps',
          component: Layout,
          name: 'temps',
          hidden: true,
          redirect: {
            name: 'messageSendList'
          },
          meta: { 
            permission: permissions['WeiXinPushMessage']
          },
          children: [
            {
              path: 'index',
              component: () => import('@/pages/message-send/index'),
              name: 'messageSendList',
              meta: {
                title: '消息管理',
                icon: 'router-child',
              }
            },
          ]
        }
        ]
        commit('SET_ROUTERS', filterAsyncRouter(asyncRouterMap))
        resolve()
      })
    }
  }
}

export default authorization